import { ApiProperty } from '@nestjs/swagger'

export class ClassLevelSummaryDto {
  @ApiProperty({ type: 'string' })
  id!: string
  @ApiProperty({ type: 'string' })
  label!: string
}
